import SimpleTrack from '@common/types/release/simple-track';
import { TracksState } from './state';
import memoize from 'lodash/memoize';

const releaseTracks = (
  tracks: TracksState['tracks'],
  releaseId?: string
): Partial<SimpleTrack>[] => {
  return Object.values(tracks)
    .filter((track) => track.releaseId === releaseId)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
};

export const trackList = memoize(
  (
    tracks: TracksState['tracks'],
    releaseId?: string
  ): Partial<SimpleTrack>[] => {
    return releaseTracks(tracks, releaseId);
  }
);

export const lastTrackNumber = (
  tracks: TracksState['tracks'],
  releaseId?: string
) => {
  return Math.max(
    0,
    ...releaseTracks(tracks, releaseId).map((k) => k.order || 0)
  );
};
